export default __webpack_public_path__ + "static/media/icon03.d4747cb3.png";